import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { TabProps } from '../types';

import {
  deviatingReimbAttandanceFields,
  deviatingReimbAttandanceFieldsOnCall,
  deviatingReimbAttandanceSchema
} from '../utils';

import Grid from '@mui/material/Grid';

import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const ControlledNumericFieldWithReadMode = withReadModeField(
  ControlledNumericField
);

const DeviatingTab = ({ setCurrentSchema }: TabProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla'
  });

  useEffect(() => {
    setCurrentSchema(deviatingReimbAttandanceSchema);
  }, []);

  return (
    <div style={{ paddingBottom: 60 }}>
      <MultiStepForm.Section title={t('deviatingReimbAttandance')}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {deviatingReimbAttandanceFields.map((item, id) => (
            <Grid
              key={`deviatingReimbAttandance_grid_${id}`}
              item
              xs={2}
              sm={4}
              md={4}
            >
              <ControlledNumericFieldWithReadMode
                key={`deviatingReimbAttandance_${id}`}
                name={item.name}
                label={t(item.label)}
                variant="outlined"
              />
            </Grid>
          ))}
        </Grid>
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('deviatingReimbOnCall')}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {deviatingReimbAttandanceFieldsOnCall.map((item, id) => (
            <Grid
              key={`deviatingReimbOnCall_grid_${id}`}
              item
              xs={2}
              sm={4}
              md={4}
            >
              <ControlledNumericFieldWithReadMode
                key={`deviatingReimbOnCall_${id}`}
                name={item.name}
                label={t(item.label)}
                variant="outlined"
              />
            </Grid>
          ))}
        </Grid>
      </MultiStepForm.Section>
    </div>
  );
};

export default DeviatingTab;
